// extracted by mini-css-extract-plugin
export default {"form":"AdminEditNoticias_form__-oo8O","input":"AdminEditNoticias_input__IpnU9","textarea":"AdminEditNoticias_textarea__q3znY","button":"AdminEditNoticias_button__EI3Kj"};